<template>
  <main class="container-selfservice-main">
    <PageTitle :title="t('interpretation_history')" :subtitle="t('interpreter_history_description')" />
    <SelfServiceChatManage domain="SELF_SERVICE" />
  </main>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import PageTitle from '@/components/domains/self-service/payment-settings/PageTitle.vue';
import SelfServiceChatManage from '@/components/self-service/chat/SelfServiceChatManage.vue';

const { t } = useI18n();
</script>

<style scoped lang="scss"></style>
